'use strict'

require('./sha512.js')

class Dispatcher {
  static _request (url, options, convertToJson) {
    // enabling cookies
    options.credentials = 'same-origin'
    return fetch(url, options).then((response) => {
      if (response.status === 403) {
        // window.location.href = '/licensing/logout'
        return
      }
      if (convertToJson) {
        return response.json()
      } else {
        return response
      }
    })
  }

  static _solveChallenge (user, password, salt, challenge) {
    let userChallenge = {}
    userChallenge.user = user
    userChallenge.challenge = challenge
    let sentence = userChallenge.challenge + password + salt
    userChallenge.response = window.sha512(sentence).toString('hex')
    console.log('userChallenge.response', userChallenge.response, sentence)
    return userChallenge
  }

  static login (loginInfo) {
    return Dispatcher._request('/licensing/login_request', {
      method: 'POST'
    }, true)
    .then((response) => {
      let challengeResponse = Dispatcher._solveChallenge(loginInfo.user, loginInfo.password, response.salt, response.challenge)
      return Dispatcher._request('/licensing/challenge_response', {
        method: 'POST',
        body: JSON.stringify(challengeResponse),
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }, true)
    })
  }

  static getSessionInfo () {
    var url = '/licensing/sessionInfo'
    return Dispatcher._request(url, {
      method: 'GET'
    }, true)
  }

  static getLicenses () {
    var url = '/licensing/licenses'
    return Dispatcher._request(url, {
      method: 'GET'
    }, true)
  }

  static getLicensesForClient (clientID) {
    var url = '/licensing/licenses/' + clientID
    return Dispatcher._request(url, {
      method: 'GET'
    }, true)
  }
}
export default Dispatcher



// WEBPACK FOOTER //
// ./src/dispatcher/dispatcher.js